import { render } from "../templates/kp-links.html?vue&type=template&id=48c2a218"
import script from "./KpLinks.vue?vue&type=script&lang=js"
export * from "./KpLinks.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__